// where will connect our frontend with the backend (sanity).

import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  // taking an object contains the following parameters.
  projectId: process.env.REACT_APP_PROJECT_ID,
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  token: process.env.REACT_APP_PROJECT_TOKEN,
  ignoreBrowserTokenWarning: true,
});

const builder = imageUrlBuilder(client);

// This is always code used whenever we using images with sanity.
export const urlFor = (source) => builder.image(source);
